import { Component, ErrorInfo, ReactNode } from "react"
import ServerError from "../app/pages/ServerError"

type Props = {
    children: ReactNode
}

type State = {
    hasError: boolean
}

export default class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false }

    static getDerivedStateFromError(): State {
        return { hasError: true }
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error("ErrorBoundary:", error, info.componentStack)
    }

    handleRetry = () => {
        this.setState({ hasError: false })
    }

    render() {
        if (this.state.hasError) {
            return <ServerError onRetry={this.handleRetry} />
        }

        return this.props.children
    }
}
